import { ChangeDetectorRef, Component } from '@angular/core';
import { LanguageRequest, LanguageService } from '../../services/language.service';
import { SwitchService } from '../../services/switch.service';
import { RoleService } from '../../services/role.service';


@Component({
  selector: 'app-role',
  standalone: false,
  templateUrl: './role.component.html',
  styleUrl: './role.component.css'
})
export class RoleComponent {

  isModalOpen = false;
  successMessage = '';
  errorMessage = '';

  roleId=0;
  languageId = 0;
  nameKh = '';
  descriptionKh = '';
  nameEn = '';
  descriptionEn = '';
  isEnabled: boolean = true;

  roles: any[] = [];

  isEnableSave: boolean = false;
  isEnableUpdate: boolean = false;
  isEnableDelete: boolean = false;

  filteredRoles: any[] = [];
  languages: any[] = [];
  activeTab: string = 'all';
  activeTabPopup: number = 1;
  searchText = '';

  constructor(
    private roleService: RoleService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
    private swService: SwitchService
  ) { }


  ngOnInit() {
    this.loadRoles();
    this.loadLanguages();
  }

  loadRoles() {
    this.roleService.getRoles().subscribe((res: any) => {
      this.roles = res.data;
      this.filteredRoles = res.data;
      this.filterRoles('kh');
    });
  }

  filterRoles(tab: string) {
    const keyword = this.searchText.trim().toLowerCase();

    this.filteredRoles = this.roles.filter(role => {
      const matchesTab = role.languageCode === tab;
      const matchesSearch = !keyword ||
        `${role.name ?? ''} ${role.description ?? ''} ${role.languageCode ?? ''}`
          .toLowerCase()
          .includes(keyword);

      return matchesTab && matchesSearch;
    });
  }

  loadLanguages() {
    this.languageService.getAll().subscribe((res: any) => {
      this.languages = res.data;
      this.languages = res.data.sort((a: { languageId: number; },b: { languageId: number; })=>a.languageId-b.languageId);
      if (this.languages.length > 0) {
        this.setTab(this.languages[0].code);
      }
    });
  }

  setTab(tab: string) {

    this.activeTab = tab;
    this.filterRoles(tab);

  }

  setTabPopup(tab: number) {
    this.activeTabPopup = tab;
  }

  getLanguageCount(lang: string): number {
    return this.roles.filter(r => r.languageCode === lang).length;
  }


  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }


  switchEnable() {
    this.swService.switchEnable(this.isEnabled);
  }


  visibleButtonControl(eventName: string) {

    this.isEnableSave = false;
    this.isEnableUpdate = false;
    this.isEnableDelete = false;

    if (eventName === 'Add') { this.isEnableSave = true }
    else if (eventName === 'Edit') { this.isEnableUpdate = true }
    else if (eventName === 'Delete') { this.isEnableDelete = true }

  }


  viewData(id: number, eventName: string) {

    this.visibleButtonControl(eventName);
    this.roleId = id;

    this.roleService.getRoleById(id).subscribe({
      next: (res) => {

        if (res.status === "success") {

          res.data.forEach((item: any) => {
            if (item.languageCode === 'kh') {
              this.nameKh = item.name;
              this.descriptionKh = item.description;
            } else if (item.languageCode === 'en') {
              this.nameEn = item.name;
              this.descriptionEn = item.description;
            }
          });

          this.openModal();
        } else {
          this.errorMessage = res.message;
        }

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      },
      error: (err) => {

        this.errorMessage = "Failed to create language";

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      }
    });

  }

  clearMsg() {
    this.successMessage = '';
    this.errorMessage = '';
  }

  addNew() {
    this.visibleButtonControl('Add');
    this.openModal();
  }

  refreshData(status: string, message: string) {

    if (status === "success") {
      this.successMessage = message;
      this.closeModal();
      this.loadRoles();
      this.resetForm();
    } else {
      this.errorMessage = message;
    }

    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);

  }

  exceptionData(message: string) {
    this.errorMessage = message;
    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);
  }

  save() {

    const request = {
      translations: [
        {
          languageId: 1, 
          name: this.nameKh,
          description: this.descriptionKh
        },
        {
          languageId: 2, 
          name: this.nameEn,
          description: this.descriptionEn
        }
      ]
    };

    this.clearMsg();

    this.roleService.create(request).subscribe({
      next: (res) => {
        this.refreshData(res.status,res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  update() {

    this.clearMsg();

    const request = {
      translations: [
        {
          languageId: 1, 
          name: this.nameKh,
          description: this.descriptionKh
        },
        {
          languageId: 2, 
          name: this.nameEn,
          description: this.descriptionEn
        }
      ]
    };

    this.roleService.update(request,this.roleId).subscribe({

      next: (res) => {
        this.refreshData(res.status,res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }

    });

  }

  delete() {

    if (!confirm("Are you sure you want to delete ?")) {
      return;
    }

    this.roleService.delete(this.roleId).subscribe({
      next: (res) => {
        this.refreshData(res.status,res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  resetForm() {
    this.roleId = 0;
    this.nameKh = '';
    this.descriptionKh = '';
    this.nameEn = '';
    this.descriptionEn = '';
    this.isEnabled = false;
  }

}
